import { buildDefaultMiddleware } from 'utilities/state';

export default buildDefaultMiddleware('location', 'store:location');